/*NAVIGATION BAR DOESNT HAVE STATES*/
import QuickViewPage from '../../../containers/QuickView.js';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import swipeDetector from '../../../businessLogic/swipeDetector';
import { redirectToInternalLink } from '../../../businessLogic/redirector';
import NavItem from './navItem.js';
import { getUserBasicProfile, getTimezones } from '../../../actions/user.js';
import { Icon } from 'semantic-ui-react';
import ChangePassword from '../../../components/pages/user/change-password/content';
import ChangeEmail from '../../../components/pages/user/change-email/content';
import ProfileContent from '../../../components/pages/user/profile/content';
import InviteWASelfProvisionPage from 'containers/InviteWASelfProvisionPage';
import WASelfProvisionExistingUser from 'containers/WASelfProvisionExistingUser';
import { updateHideWhenClickAwayQuickView, updateShowQuickViewModal } from '../../../actions/modal';
import HelpMenuDropdown from '../menu-options/helpMenu';
import UserMenuDropdown from '../menu-options/userMenu';
import MyRolesPage from '../../../containers/MyRolesPage';

export default function NavigationBar(props) {
  const dispatch = useDispatch();
  // values from redux
  const loggedIn = useSelector((state) => state.usersReducer.loggedIn);
  const currentPageTitleFromRedux = useSelector((state) => state.navigationBarReducer.currentPageTitle);
  const timezones = useSelector((state) => state.usersReducer.timezones);
  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hideHelpAboutThisPage = useSelector((state) => state.sharedReducer.hideHelpAboutThisPage);
  const redirectToPageFeatureUnavailable = useSelector((state) => state.sharedReducer.redirectToPageFeatureUnavailable);
  const hasAdminRights = useSelector((state) => state.usersReducer.userProfile.hasAdminRights);

  const hasWaitingAreas = useSelector((state) =>
    state.usersReducer.userProfile &&
    state.usersReducer.userProfile.hasEntityAdminRights &&
    state.usersReducer.userProfile.hasEntityAdminRights.isOrgAdmin &&
    state.usersReducer.userProfile.shouldLoadDirectlyAssociatedWAs
      ? state.usersReducer.userProfile.hasDirectlyAssociatedWaitingAreas
      : state.usersReducer.userProfile.hasWaitingAreas
  );

  const hasMeetingRooms = useSelector((state) => state.usersReducer.userProfile.hasMeetingRooms);
  const hasEntityAdminRights = useSelector((state) => state.usersReducer.userProfile.hasEntityAdminRights);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile.isAdmin);
  const hasReports = useSelector((state) => state.usersReducer.userProfile.hasReports);
  const user = useSelector((state) => state.usersReducer.userProfile);
  const showMyRolesModal = useSelector((state) => state.modalReducer.showMyRolesModal);
  // end

  const [leftOrTop, setLeftOrTop] = useState('top horizontal');
  const [menuIsHidden, setMenuIsHidden] = useState(true);
  const [currentPageTitle, setCurrentPageTitle] = useState(currentPageTitleFromRedux || '');
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [amILeftAligned, setAmILeftAligned] = useState();

  useEffect(() => {
    //Constructor on load method call
    swipeDetector.detectFingerMovement();
    //

    window.document.body.addEventListener('click', hideMenu);
    window.addEventListener('resize', moveToLeftOrRight);

    // component will mount lifecycle event
    moveToLeftOrRight();
    if (!timezones || timezones.length == 0) dispatch(getTimezones());
    // end component will mount

    return () => {
      window.document.body.removeEventListener('click', hideMenu);
      window.removeEventListener('resize', moveToLeftOrRight);
    };
  }, []);

  const hideMenu = (e) => {
    //basically, we try to avoid doing anything if the hide button or a menu item gets clicked
    let targetClasses = e.target.className;
    if (
      targetClasses.indexOf('item') > -1 &&
      e.target.childElementCount === 0 &&
      targetClasses.indexOf('menu-button') < 0
    ) {
      let childClasses = e.target.className;
      if (childClasses.indexOf('sidebar-menu') > -1) {
        //this is the tiny icon like a hamburguer
        return;
      }
    }
    if (
      targetClasses.indexOf('no-sub-menu') < 0 &&
      e.target.nodeName != 'A' &&
      $(e.target).closest('.menu.left').length > 0 &&
      (targetClasses.indexOf('dropdown') > -1 ||
        $(e.target).parent('.dropdown').length > 0 ||
        targetClasses.indexOf('has-sub-menu') > -1 ||
        $(e.target).parent('.has-sub-menu').length == 1 ||
        ($(e.target).find('~.has-sub-menu').length > 0 && targetClasses.indexOf('has-sub-menu') < 0))
    ) {
      console.log(`ignore all clicks of items within the menu`);
      //ignore all clicks of items within the menu
      return;
    }
    setMenuIsHidden(true);
  };

  const toggleMenu = () => {
    setMenuIsHidden(!menuIsHidden);
  };

  useEffect(() => {
    setCurrentPageTitle(currentPageTitleFromRedux);
    setQuickViewVisible(props.quickViewVisible);
  }, [currentPageTitleFromRedux, props.quickViewVisible]);

  const helpWithCurrentPage = () => {
    if (currentPageTitle == APP.LANGUAGE.ViewMeetingRoom.Title)
      window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpMeetingRoom, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.ViewWaitingArea.Title)
      window.open(APP.EXTERNAL_LINKS.ViewWaitingArea.HelpWaitingArea, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.ViewOneWaitingArea.Title)
      window.open(APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpViewOneWaitingArea, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.UserProfile.TitleClean)
      window.open(APP.EXTERNAL_LINKS.UserProfile.MoreInfo, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.MainReport.Title)
      window.open(APP.EXTERNAL_LINKS.Report.HelpAboutReportPage, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle) {
      if (window.location.pathname.indexOf('meeting') > -1) {
        window.open(APP.EXTERNAL_LINKS.MeetingRoomManageUsers.HelpAboutUsersPage, 'mgt-console-help');
      } else {
        window.open(APP.EXTERNAL_LINKS.ManageUsers.HelpAboutUsersPage, 'mgt-console-help');
      }
    } else if (currentPageTitle == APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle) {
      window.open(APP.EXTERNAL_LINKS.OrganisationManageUsers.HelpAboutUsersPage, 'mgt-console-help');
    } else if (currentPageTitle == APP.LANGUAGE.ViewAllOrgUnit.Title)
      window.open(APP.EXTERNAL_LINKS.OrgUnit.HelpAboutOrgUnitPage, 'mgt-console-help');
    else if (
      currentPageTitle == APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle ||
      currentPageTitle == APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle
    )
      window.open(APP.EXTERNAL_LINKS.ManageTaggings.HelpAboutManageTagsPage, 'mgt-console-help');
    else if (currentPageTitle == APP.LANGUAGE.ManageAllUsers.Title)
      window.open(APP.EXTERNAL_LINKS.ManageAllUsers.HelpAboutManageAllUsersPage, 'mgt-console-help');
  };
  const setZoom = (zoomAmmount) => {
    window.$(document.body).css('zoom', zoomAmmount);
  };
  const moveToLeftOrRight = () => {
    window.$('body').click();
    if (window.matchMedia('(min-width: ' + window.styleVariable.tabletNavigationMinWidthPx + ')').matches) {
      //for screens greater than mobile
      setLeftOrTop('ui  menu top-aligned color-primary  brdr-radius-null ');
      setAmILeftAligned(false);
      setMenuIsHidden(true);
    } else {
      setLeftOrTop('ui left fixed vertical menu color-primary  mxwdtpxxxxll ');
      setAmILeftAligned(true);
      setMenuIsHidden(true);
    }
  };

  const showQuickView = () => {
    //////////////////////////////////RECENT CALLS LOGIC START///////////////////////////////////////////////////
    //Loading meeting room recent calls when home button is clicked.
    let cb = () => {};
    var selector = '.meeting-room-recent-calls'; //hiding recent calls context menu when quick-view opens
    window.$(selector).find('.row.active').toggleClass('active', false);
    window.$(selector).find('.contextual-menu-content').toggleClass('hidden', true);
    //////////////////////////////////RECENT CALLS LOGIC END///////////////////////////////////////////////////
    let show = true;
    let hideWhenClickAway = true;
    dispatch(updateHideWhenClickAwayQuickView(hideWhenClickAway));
    dispatch(updateShowQuickViewModal(show));
  };
  const hideQuickView = () => {
    let show = false;
    dispatch(updateShowQuickViewModal(show));
  };

  const itemClass = amILeftAligned ? 'menu-items-left-aligned no-sub-menu' : '';
  const subMenuItemParentClass = amILeftAligned ? 'menu-items-left-aligned has-sub-menu' : '';

  //Menu options and submenu options
  const supaDropdownUserMenuClassName = amILeftAligned
    ? 'top left user-item pointing item pdlm'
    : 'ui dropdown user-item item';
  const supaDropdownHelpMenuClassName = amILeftAligned ? 'top left pointing item help-item' : 'help-item  item ';
  const helpMenuOptionTrigger = <Icon name="help" className="fl" />;
  //End Menu options

  //end helping menu options
  let quickViewMenu = '';
  if (loggedIn) {
    quickViewMenu = (
      <QuickViewPage
        onClose={hideQuickView}
        loggedInUserHandler={() => {
          hideQuickView();
        }}
        renderOnMount={false}
      />
    );
  }
  // This includes service admin & mr admin
  // let canSeeEntityAdminPage =
  //   this.props.hasEntityAdminRights != undefined &&
  //   this.props.isAdmin != undefined &&
  //   (this.props.hasEntityAdminRights.isOrgAdmin ||
  //     this.props.hasEntityAdminRights.isServiceAdmin ||
  //     this.props.hasEntityAdminRights.isMeetingRoomAdmin ||
  //     this.props.isAdmin);

  // This excludes service admin & mr admin
  const canSeeEntityAdminPage =
    hasEntityAdminRights != undefined && isAdmin != undefined && (hasEntityAdminRights.isOrgAdmin || isAdmin);

  let innerMenu = '';
  innerMenu = (
    <div className={leftOrTop} data-menu-is-hidden={menuIsHidden && amILeftAligned}>
      <div className="scroll-wrapper">
        <div className="vertical-menu-wrapper">
          <a
            className="menu-button color-button color-white item color-button-hover brdr-radius-null hand my-flex"
            onClick={hideQuickView}
          >
            <span className="text">Menu</span>
            <i className="big-x">&times;</i>
          </a>
          <a
            className="button item mrlm text-size-xl quick-view-shortcut"
            onClick={showQuickView}
            data-show={hasWaitingAreas || hasMeetingRooms || hasReports || canSeeEntityAdminPage}
          >
            <Icon name="home" size="large" />
          </a>
          {loggedIn ? quickViewMenu : ''}
          {hasWaitingAreas ? <NavItem text={APP.LANGUAGE.Menu.WaitingAreas} isIndex url="waiting-area/view-all" /> : ''}
          {hasMeetingRooms ? <NavItem text={APP.LANGUAGE.Menu.MeetingRooms} url="meeting-room/view-all" /> : ''}
          {canSeeEntityAdminPage ? (
            <NavItem text={APP.LANGUAGE.Menu.EntityAdmin} url="organisational-unit/view-all" />
          ) : (
            ''
          )}
          {hasAdminRights ? <NavItem text={APP.LANGUAGE.Menu.Users} url="user/view-all" /> : ''}
          {hasReports ? <NavItem text={APP.LANGUAGE.Menu.Report} url="report" /> : ''}
          <a className="item text" href={APP.EXTERNAL_LINKS.RC.HomePage} target="_blank">
            {APP.LANGUAGE.Menu.ResourceCentre}
          </a>

          <NavItem
            text="search"
            searchBar
            url="search"
            amILeftAligned={amILeftAligned}
            cssClasses={
              !window.hideUnfinishedItems ? 'hidden-when-left search-bar' : 'hidden-when-left search-bar' + ' invisible'
            }
          />
          <HelpMenuDropdown
            subMenuItemParentClass={subMenuItemParentClass}
            subMenuClass="left menu sub-menu-items"
            trigger={helpMenuOptionTrigger}
            user={user}
            itemClass={itemClass}
            HelpWithThisPageOnClick={helpWithCurrentPage}
            helpMenuClassName={supaDropdownHelpMenuClassName}
            redirectToPageNotFound={redirectToPageNotFound}
            hideHelpAboutThisPage={hideHelpAboutThisPage}
            redirectToPageFeatureUnavailable={redirectToPageFeatureUnavailable}
            childOnClickfunc={() => {
              setMenuIsHidden(true);
            }}
            dispatch={dispatch}
          />
          <UserMenuDropdown
            itemClass={itemClass}
            subMenuItemParentClass={subMenuItemParentClass}
            subMenuClass="left menu sub-menu-items"
            userAvatarSize={amILeftAligned ? 31 : 33}
            userAvatarTextRatio={amILeftAligned ? 2.3 : 2.5}
            user={user}
            userMenuClassName={supaDropdownUserMenuClassName}
            childOnClickfunc={() => {
              setMenuIsHidden(true);
            }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="color-primary" data-show={loggedIn}>
      <div className="ui menu top-aligned color-primary  brdr-radius-null" data-menu-is-hidden={!amILeftAligned}>
        <a className="ui item sidebar-menu" onClick={toggleMenu}>
          Menu
        </a>
        <NavItem
          text="search"
          searchBar
          url="search"
          cssClasses={!window.hideUnfinishedItems ? 'mrrnull search-bar' : 'mrrnull search-bar' + ' invisible'}
          amILeftAligned={false}
        />
        <ChangePassword />
        <ChangeEmail />
        <ProfileContent />
        <InviteWASelfProvisionPage />

        {showMyRolesModal == true ? <MyRolesPage /> : ''}
        <WASelfProvisionExistingUser />
      </div>
      {innerMenu}
    </div>
  );
}
